module.exports = __webpack_public_path__ + "img/phon5.d96e97ee.png";